module.exports = __webpack_public_path__ + "static/img/14.d771915.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/zh/14.png
// module id = r2N+
// module chunks = 0